import { getPasswordForgottenUrl, pagePaths } from '../config';

export const getForgottenUrl = (currentLanguageCode: string, username: string): string => {
  return process.env.REACT_APP_FF_WITH_NEW_EMAIL_RESET === 'true'
    ? pagePaths.PasswordForgotten
    : `${getPasswordForgottenUrl(
        currentLanguageCode === 'en-GB' ? 'en-US' : currentLanguageCode
      )}?email=${username}`;
};
